import React from 'react'
import styled from 'styled-components'

import { CSVLink } from "react-csv";
import { Icon } from '.'

const StyledButton = styled(CSVLink)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    width: 120px !important;
    height: 40px !important;
    font-size: 10px !important;
    background-color: ${props => props.theme.colors.success};

    &:hover {
        text-decoration: none;
        background-color: ${props => props.theme.colors.success};
    }
`

const Text = styled.span`
    padding-top: 3px;
    color: white;
    text-decoration: none;
    font-size: 12px;

`

export const CSVButton = ({headers, data, title}) => (
    <StyledButton headers={headers} data={data} filename={`${title}.csv`}>
        <Icon name={'csv'} />
        <Text>Exportar CSV</Text>
    </StyledButton>
)